// OfferTableProductNameCell.tsx
import * as React from 'react';
import { connect } from 'react-redux';
import { ApplicationState } from '../store';
import * as OfferStore from '../store/Offer';

interface ProductNameCellOwnProps {
    productId: number; 
}

interface ProductNameCellConnectedProps {
    productName: string;
}

type ProductNameCellProps = ProductNameCellOwnProps & ProductNameCellConnectedProps;

const ProductNameCellComponent: React.FC<ProductNameCellProps> = React.memo(({ productName }) => {
    return <span>{productName}</span>;
});

const mapStateToProps = (state: ApplicationState, ownProps: ProductNameCellOwnProps) => {
    const products = OfferStore.productPromoFilteredSelector(state);
    const product = products.find(p => p.storeItemId == ownProps.productId);
    return {
        productName: product?.name || ''
    };
};

export const ProductNameCell = connect(mapStateToProps)(ProductNameCellComponent);